import { createEffect, createSignal, For, Show } from "solid-js";
import { cn } from "@/libs/cn";
import { Button } from "@/components/shadcn/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/shadcn/dropdown-menu";
import {
  Checkbox,
  CheckboxControl,
} from "@/components/shadcn/checkbox";
import { Icon } from "@iconify-icon/solid";
import { Badge } from "@/components/ui/Badge";

export const TableAction = (props) => {
  const [checked, setChecked] = createSignal(false);

  const onChange = (checked) => {
    props.onCheck(checked);
  }

  createEffect(() => {
    props.checkedItems;
    setChecked(props.checkedItems.length > 0 && props.checkedItems.length === props.items);
  });

  createEffect(() => {
    props.items;
    setChecked(props.checkedItems.length > 0 && props.checkedItems.length === props.items);
  });

  return (
    <Show when={props.actions.length > 0}>
      <div class="flex items-center gap-2">
        <Checkbox class="flex items-center" checked={checked()} onChange={(checked) => onChange(checked)}>
          <CheckboxControl class="border-gray-400 shadow-none" />
        </Checkbox>
      </div>
    </Show>
  );
}
